/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component(
//     'example-component',
//     require('./components/ExampleComponent.vue').default
// );

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import CategoryHaveChild from './components/CategoryHaveChild';
import qaItem from './components/qaItem';
import mbMenu from './components/mbMenu';
import mbMenuSec from './components/mbMenuSec';
import Swiper from 'swiper/bundle';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'animate.css';
// import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import "simplebar";
import 'simplebar/dist/simplebar.css';


AOS.init({
    once: true,
});

const app = new Vue({
    el: '#app',
    components: {
        CategoryHaveChild,
        qaItem,
        mbMenu,
        mbMenuSec,
    },
    data: {
        mobileMenuBtn: false,
    },
    methods: {
        toggleMobileHeader() {
            this.mobileMenuBtn = !this.mobileMenuBtn;
        },
    },
});

const homeBanner = document.querySelectorAll('.home_banner__single');
const changeBgSize = function (arr) {
    if (window.innerWidth > 768) {
        arr.forEach(item => {
            item.style.backgroundImage = `url('${item.dataset.pcbg}')`;
        });
    } else {
        arr.forEach(item => {
            item.style.backgroundImage = `url('${item.dataset.mbbg}')`;
        });
    }
};
changeBgSize(homeBanner);

const swiper = new Swiper('.home_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 1000,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.home_pagination',
        type: 'bullets',
        clickable: 'true',
    },
    on: {
        beforeInit: function () {
            const swiperBanner = document.querySelectorAll(
                '.home_swiper .home_banner'
            );
            changeBgSize(swiperBanner);
        },
        init: function () {
            const animateArray =
                this.slides[this.activeIndex].querySelectorAll(
                    '.animate__animated'
                );
            animateArray.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('animate__fadeInUp');
                }, 1000 * (index / 2));
            });
        },
        slideChange: function () {
            const index = swiper.activeIndex;
            const animateArray =
                this.slides[index].querySelectorAll('.animate__animated');
            animateArray.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('animate__fadeInUp');
                }, 1000 * (index / 2));
            });

            //移除其他slide的背景效果跟文字效果
            const array = [...swiper.slides];
            array.splice(index, 1);
            array.forEach(element => {
                element
                    .querySelectorAll('.animate__animated')
                    .forEach(item =>
                        item.classList.remove('animate__fadeInUp')
                    );
            });
        },
    },
});

const swiperNews = new Swiper('.news_swiper', {
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 15,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    breakpoints: {
        450: {
            slidesPerView: 1.5,
            slidesBetween: 20,
        },
        780: {
            slidesPerView: 2.5,
            spaceBetween: 20,
        },
        1080: {
            slidesPerView: 3.5,
            spaceBetween: 15,
        },
    },
});

const galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 15,
    slidesPerView: 5,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    slideToClickedSlide: true,
});

const galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    thumbs: {
        swiper: galleryThumbs,
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`
            );
            let nextSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`
            );
            let prevSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`
            );
            if (
                nextSlide &&
                !nextSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slideNext();
            } else if (
                prevSlide &&
                !prevSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slidePrev();
            }
        },
    },
});
